import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GMB_STATUS } from '@boxx/gmb-core';
import { OnboardingStore } from '@boxx/onboarding-core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { takeUntil, withLatestFrom } from 'rxjs/operators';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { QrPopoverComponent } from './qr-popover.component';
import { TotalplayComponent } from './totalplay/totalplay.component';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-qr-component',
  templateUrl: './qr-component.html',
  styleUrls: ['./qr-component.scss'],
})
export class QrComponent implements OnInit, OnDestroy {
  showPopover: boolean = false;
  showQR: boolean = true;
  @Input() loading$: Observable<boolean>; 
  @Input() hasGBPSync: boolean;
  @Input() showWizardItem: boolean;
  @Input() brandName: string;
  @Input() third_id: string;
  
  //@Input() sites: any[];
  @Input() set sites(urlSites: any[]) {
      if (urlSites && urlSites.length > 0) {
        this.openDefaultModal();
        if(urlSites.length > 1){
          for(let i = 0; i < urlSites.length; i++){
            this.showQR = true;
            if(urlSites[i].type === 'agency_website'){
              this.websiteUrl = urlSites[i].url;
            }
            else if(urlSites[i].type === 'shop'){
              this.storeUrl = urlSites[i].url;
            }
            else if(urlSites[i].type === 'directory'){
              this.directoryUrl = urlSites[i].url;
            }
            if(this.websiteUrl !== undefined && this.storeUrl !== undefined){
              this.showPopover = true;
            }
          }
        }
        else{
          this.websiteUrl = urlSites[0].url;
        }
      }
  }
  @Input() openModal: string;

  destroyed$ = new Subject<boolean>();
  gmbStatus: GMB_STATUS;
  gmbData: any;
  openQRFirstTime: boolean;

  websiteUrl: string;
  storeUrl: string;
  directoryUrl: string;

  constructor(
    private popoverController: PopoverController,
    private modalController: ModalController,
    public storageService: LocalStorageNativeService,
    private storeBusiness: OnboardingStore,
    private utils: BoxxUtilsService
  ) {}

  ngOnInit() {
    this.storeBusiness.businessConfig.gmbStatusData$
      .pipe(
        withLatestFrom(this.storeBusiness.businessConfig.businessData$),
        takeUntil(this.destroyed$)
      )
      .subscribe(async ([gmbData, businessData]) => {
        if (businessData?.config?.hasGmbAccount) {
          this.gmbStatus = gmbData.status;
          this.gmbData = gmbData.data;
        } else if (businessData?.config?.hasGmbAccount) {
          this.gmbStatus = 'IN_PROCESS';
        } else {
          this.gmbStatus = 'NO_GMB';
        }
      });

    this.storeBusiness.businessConfig.gmbStatusHasBeenFetched$
      .pipe(
        withLatestFrom(this.storeBusiness.businessConfig.businessData$),
        takeUntil(this.destroyed$)
      )
      .subscribe(([fetched, businessData]) => {
        if (businessData?.config?.hasGmbAccount && !fetched) {
          this.storeBusiness.businessConfig.getGmbLocationStatus();
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  async openDefaultModal() {
    if(this.brandName.toUpperCase() === 'TOTALPLAY'){
      if(this.third_id !== undefined && this.third_id !== null && this.third_id !== 'undefined' && (this.third_id.length > 0)){
        this.showQrModal();
      }
      else{

          const countModal = await this.storageService.getItem('count_modal_tp');
          if (!countModal || countModal === null) {
            await this.storageService.setItem('count_modal_tp', 1);
            const popover = await this.popoverController.create({
              component: TotalplayComponent,
              componentProps: {
                countOpen: 1
              },
              backdropDismiss: false,
              cssClass: 'qr-popover',
            });
            await popover.present();
          }
          else{
            let totalOpen = Number(countModal);
            if(Number(countModal) < 3){
              totalOpen = Number(countModal) + 1
              await this.storageService.setItem('count_modal_tp', totalOpen);
            }
            const popover = await this.popoverController.create({
              component: TotalplayComponent,
              componentProps: {
                countOpen: totalOpen
              },
              backdropDismiss: false,
              cssClass: 'qr-popover',
            });
            await popover.present();
          }

      }

    }
    else{
      this.showQrModal();
    }
  }

  async showQrModal(){
    const obDataStr = await this.storageService.getItem('first_load_modal');
    if (!obDataStr || obDataStr === null) {
      this.openQRFirstTime = true;
      setTimeout(async () => {
        this.openQRPopover();
        //await this.storageService.setItem('first_load_modal', true);
      }, 1000);
    }
    else{
      this.openQRFirstTime = false;
    }
  }

  async openQRPopover() {
    console.log('a');
    this.utils.openBottomSheet({
      data: [
        { key: 'gallery', value: 'generals.gallery', icon: 'gallery-opt' },
        { key: 'camera', value: 'generals.camera', icon: 'camera-opt' }
      ],
      type: BottomSheetType.options,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: 'profile.addPicture',
      maxHeigth: 35
    }).then((data) => {
      if (data?.value) {
        //this.selectMethod(data?.value);
      }
    });
    // const popover = await this.popoverController.create({
    //   component: QrPopoverComponent,
    //   componentProps: {
    //     websiteUrlString: this.websiteUrl,
    //     gmbUrlString: this.gmbData?.metadata?.mapsUrl,
    //     openQRFirstTime: false,
    //     hasGBPSync: this.hasGBPSync,
    //     showWizardItem: this.showWizardItem
    //   },
    //   cssClass: 'qr-popover',
    // });
    // await popover.present();
  }

  async openDirectQRPopover() {
    console.log('b');
    const popover = await this.popoverController.create({
      component: QrPopoverComponent,
      componentProps: {
        websiteUrlString: this.websiteUrl,
        gmbUrlString: this.gmbData?.metadata?.mapsUrl,
        openQRFirstTime: true,
        hasGBPSync: this.hasGBPSync,
        urlType: 1
      },
      cssClass: 'qr-popover',
    });
    await popover.present();
  }

  async openCustomQRPopover(siteType: number) {
    let url;
    if(this.websiteUrl && this.websiteUrl !== undefined && siteType === 1){
      url = this.websiteUrl
    }
    else if(this.storeUrl && this.storeUrl !== undefined && siteType === 2){
      url = this.storeUrl
    }
    else if(this.directoryUrl && this.directoryUrl !== undefined){
      url = this.directoryUrl
    }
    this.popoverController.dismiss();
    const popover = await this.popoverController.create({
      component: QrPopoverComponent,
      componentProps: {
        websiteUrlString: url,
        gmbUrlString: this.gmbData?.metadata?.mapsUrl,
        openQRFirstTime: true,
        hasGBPSync: this.hasGBPSync,
        urlType: siteType
      },
      cssClass: 'qr-popover',
    });
    await popover.present();
  }

}
